/**
 * @license lucide-vue-next v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Circle = createLucideIcon("circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);

export { Circle as default };
//# sourceMappingURL=circle.js.map
